<app-popup-wrapper (closeEvent)="closePopup($event)">
    <ng-container title>
        {{ 'v3-logout-popup-header-text' | translate }}
    </ng-container>

    <ng-container content>
        {{ 'v3-logout-popup-description-text' | translate }}
    </ng-container>

    <ng-container buttons>
        <button
            app-button-outline
            size="md"
            severity="secondary"
            [text]="'v3-button-log-out' | translate"
            (click)="closePopup('logout')"
            buttonDataTest="logoutButton"
        ></button>
        <button
            (click)="closePopup('close')"
            app-button
            severity="primary"
            size="md"
            [text]="'v3-button-keep-logged-in' | translate"
            buttonDataTest="keepLoggedInButton"
        ></button>
    </ng-container>

    <ng-container checkbox>
        <form [formGroup]="form">
            <app-forms-checkbox controlName="notShowAgain" [label]="'v3-global-do-not-display-this-warning' | translate" />
        </form>
    </ng-container>
</app-popup-wrapper>
